import React, { useEffect, useState } from 'react'
// import { useSelector } from "react-redux";
import { useSelector, useDispatch } from "react-redux";
import { Link, useNavigate } from 'react-router-dom'
import {
  Container,
  Row,
  Col,
  ListGroup,
  ListGroupItem,
} from 'reactstrap';
import Header from '../parts/Header'
import NaranciaSubHeader from '../parts/NaranciaSubHeader'
import * as MyAPI from '../../../utils/MyAPI'
import * as AbstructedApi from '../../../utils/AbstructedApi'
import * as UserActions from '../../../actions/UserActions'
import Alert from 'react-s-alert';
import { Loader } from 'react-overlay-loader';
import 'react-overlay-loader/styles.css';
import NaranciaListItem from './NaranciaListItem'

// NaranciaTop
const NaranciaTop = (props) => {

  let dispatch = useDispatch();

  let navigate = useNavigate();
  let login_token = useSelector(state => {
    if (state.user && state.user.login_token) {
      return state.user.login_token
    } else {
      return ''
    }
  });
  let subscription_status = useSelector(state => {
    if (state.user && state.user.subscription_status) {
      return state.user.subscription_status
    } else {
      return 'unknown'
    }
  });

  let [loading, setLoading] = useState(false);
  let [audioList, setAudioList] = useState([])
  // let [subscriptionStatus, setSubscriptionStatus] = useState("unknown");

  // componentDidMount
  useEffect(() => {
    _firstScript()

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  let _firstScript = async () => {

    if (!login_token) {
      // redirect
      navigate("/dashboard")
      return;
    }

    // check subscription status
    if (subscription_status === "unknown") {
      let _obj = await AbstructedApi.checkSubscriptionStatus(login_token)
      dispatch(UserActions.setSubscriptionStatus({
        subscription_status: _obj.subscription_status,
      }))
    }
  }

  // componentDidMount
  useEffect(() => {

    // _firstScript()

    if (subscription_status === "active") {
      _secondScript()
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [subscription_status]);

  // get list
  let _secondScript = async () => {

    setLoading(true)

    try {

      // get evaluation masters
      const results_1 = await MyAPI.getNaranciaList({
        login_token: login_token,
      })
      if (results_1.status !== "success") {
        throw Error(results_1.message)
      }
      console.log("getNaranciaList.results_1: ", results_1)

      if (results_1.list1) {
        setAudioList(results_1.list1)
      }

    } catch (err) {
      console.log("err: ", err )

      Alert.error(err.message, {
        position: 'top-right',
        effect: 'slide',
        timeout: 5000
      });

    }
    setLoading(false)
  }










  // save nickname
  let _saveNickname = async ({
    narancia_id,
    nickname,
  }) => {
    console.log("_saveNickname ", narancia_id, nickname)

    setLoading(true)

    try {

      // get voice to check
      const results_1 = await MyAPI.setNaranciaNickname({
        login_token: login_token,
        narancia_id: narancia_id,
        nickname: nickname,
      })

      if (results_1.status !== "success") {
        throw Error(results_1.message)
      }

      Alert.success("ok", {
        position: 'top-right',
        effect: 'slide',
        timeout: 5000
      });

      // get call list again
      await _secondScript()

    } catch (err) {
      console.log("err: ", err )

      Alert.error(err.message, {
        position: 'top-right',
        effect: 'slide',
        timeout: 5000
      });

    }

    setLoading(false)
  }










  return (
    <div>

      <Header />

      <NaranciaSubHeader />

      {/* main */}
      <Container style={{
        marginTop: 40,
      }}>

        <div style={{
          marginTop: 20,
          marginBottom: 20,
        }}>

          <ListGroup style={{
            marginTop: 20,
            marginBottom: 20,
          }}>

            {/* header */}
            {props.masterList && props.masterList.length > 0 && (
              <ListGroupItem style={{
                backgroundColor: '#ffffff',
                color: '#555555',
              }}>
                <Row>
                  <Col md="3" xs="12">
                    日付
                  </Col>
                  <Col md="3" xs="12">
                    ファイル名
                  </Col>
                  <Col md="2" xs="12" style={{
                    textAlign: 'center',
                  }}>
                    長さ
                  </Col>
                  <Col md="2" xs="12" style={{
                    textAlign: 'center',
                  }}>
                    ステータス
                  </Col>
                  <Col md="2" xs="12">

                  </Col>
                </Row>
              </ListGroupItem>
            )}

            {audioList && audioList.map((item) => (
              <NaranciaListItem
                saveNickname={_saveNickname}
                key={item._id+item.status}
                item={item} />
            ))}

          </ListGroup>
        </div>

      </Container>

      {/* loading */}
      <Loader fullPage={true} loading={loading} />

    </div>
  )
}

export default NaranciaTop
